import { ISubscriptionPlanState } from '../../../types'
import * as constants from '../../constants/index'
import { ISubscriptionActions } from '../../actions/subscriptions'

const initialState: ISubscriptionPlanState = {
  isFetching: false,
  error: null,
  items: []
}

export function subscriptionPlans(state: ISubscriptionPlanState, action: ISubscriptionActions): ISubscriptionPlanState {
  if (typeof state === 'undefined') {
    return initialState
  }

  switch (action.type) {
    case constants.LIST_SUBSCRIPTION_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case constants.LIST_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        isFetching: false,
        items: action.payload
      }
    case constants.LIST_SUBSCRIPTION_FAIL:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers/subscriptions/index.ts